export default __webpack_public_path__ + "static/media/logo_only.4c522c77.svg";